import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/company-watcher`;

export const keyName = "CompanyWatcher";

const fetchCompanyWatchers = async ({ companyId, userId }, appAxios) => {
  const { data } = await appAxios.get(`${path}/`, {
    params: { company: companyId, user: userId },
  });
  return data;
};

const createCompanyWatcher = async (newWatcher, appAxios) => {
  const { data } = await appAxios.post(`${path}/`, newWatcher);
  return data;
};

const deleteCompanyWatcher = async (id, appAxios) => {
  await appAxios.delete(`${path}/${id}/`);
};

export const useGetCompanyWatchers = (companyId) => {
  const { appAxios } = useContext(AuthenticationContext);
  return useQuery({
    queryKey: [keyName, companyId],
    queryFn: () => fetchCompanyWatchers({ companyId }, appAxios),
    enabled: !!companyId,
  });
};

export const useCreateCompanyWatcher = () => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);
  return useMutation({
    mutationFn: ({ companyId, userId }) =>
      createCompanyWatcher(
        { company_id: companyId, user_id: userId },
        appAxios,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [keyName] });
    },
  });
};

export const useDeleteCompanyWatcher = () => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);
  return useMutation({
    mutationFn: (id) => deleteCompanyWatcher(id, appAxios),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [keyName] });
    },
  });
};
